import React, { useEffect, useRef, useState } from 'react'
import { motion } from "framer-motion";
import { Link } from 'react-router-dom';
import FooterContact from '../../component/FooterContact';
import HomeVideo2 from '../../assets/images/banner/banner-1.mp4';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { Pagination, Autoplay } from 'swiper/modules';
import { Parallax, useParallax } from 'react-scroll-parallax';


export default function Leadership() {

    const parallax = useParallax < HTMLDivElement > ({
        rotateY: [0, 360],
    });

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);


    return (
        <>

            <section className="pad60 box-shadow innertopbanner" style={{ position: 'relative', overflow: 'hidden' }}>
                {/* <div className="overlay-top-left"></div> */}
                <div className="container">
                    <div className="row align-items-center height100">
                        <div className="col-lg-6 col-md-12">
                            <div className="banner-caption">
                                <div itemscope="" itemtype="http://schema.org/BreadcrumbList" className="breadcrumbs">
                                    <ul>
                                        <li itemprop="itemListElement" itemscope="" itemtype="http://schema.org/ListItem">
                                            <Link to="/">
                                                <span itemprop="name">Home</span>
                                            </Link>
                                            <meta itemprop="position" content="1" />
                                        </li>
                                        <li itemprop="itemListElement" itemscope="" itemtype="http://schema.org/ListItem">
                                            <i className="icofont-thin-right"></i>
                                            <Link to="/contact#">
                                                <span itemprop="name">Leadership</span>
                                            </Link>
                                            <meta itemprop="position" content="2" />
                                        </li>
                                    </ul>
                                </div>
                                <h1>Leadership Team</h1>
                                <p>The driving force behind our inspiration every day.</p>
                                <div className='button_services'>
                                    <Link to="/contact"><button>Contact Us</button></Link>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-12">
                            <div className="banner-mobiles text-center">
                                <img src={require('../../assets/images/services/products/data-bg-transparant.webp')} alt="CLOUD MIND banner" />
                            </div>
                        </div>
                    </div>
                </div>

                <video autoPlay loop muted style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    zIndex: -1
                }}>
                    <source src={HomeVideo2} type="video/mp4" />
                </video>
            </section>


            <section className='about-section-4 top bottom padding-left-right team-section-1'>
                <div className='container-fluid'>
                    <div className='header-title header-center mb-5'>
                        <h2 className='heading text-white'>Meet The Professionals</h2>
                    </div>
                    <>
                        <div className='row'>
                            <div className='col-lg-4 col-md-4 col-sm-6'>
                                <div className='team-profile'>
                                    <div className='profile-box'>
                                        <img src={require('../../assets/images/blue-circle.avif')} />
                                        <div className='team-social-media'>
                                            <li>
                                                <a href="#"><i className="fa-brands fa-facebook-f"></i></a>
                                            </li>
                                            <li>
                                                <a href="#"><i className="fa-brands fa-instagram"></i></a>
                                            </li>
                                            <li>
                                                <a href="#"><i className="fa-brands fa-linkedin-in"></i></a>
                                            </li>
                                        </div>
                                    </div>
                                    <h4>Dinesh Pratap Yadav</h4>
                                    <h5>CEO & Founder</h5>
                                </div>
                            </div>
                            <div className='col-lg-4 col-md-4 col-sm-6'>
                                <div className='team-profile'>
                                    <div className='profile-box'>
                                        <img src={require('../../assets/images/blue-circle.avif')} />
                                        <div className='team-social-media'>
                                            <li>
                                                <a href="#"><i className="fa-brands fa-facebook-f"></i></a>
                                            </li>
                                            <li>
                                                <a href="#"><i className="fa-brands fa-instagram"></i></a>
                                            </li>
                                            <li>
                                                <a href="#"><i className="fa-brands fa-linkedin-in"></i></a>
                                            </li>
                                        </div>
                                    </div>
                                    <h4>Manish Yadav</h4>
                                    <h5>Software Engineer</h5>
                                </div>
                            </div>
                            <div className='col-lg-4 col-md-4 col-sm-6'>
                                <div className='team-profile'>
                                    <div className='profile-box'>
                                        <img src={require('../../assets/images/blue-circle.avif')} />
                                        <div className='team-social-media'>
                                            <li>
                                                <a href="#"><i className="fa-brands fa-facebook-f"></i></a>
                                            </li>
                                            <li>
                                                <a href="#"><i className="fa-brands fa-instagram"></i></a>
                                            </li>
                                            <li>
                                                <a href="#"><i className="fa-brands fa-linkedin-in"></i></a>
                                            </li>
                                        </div>
                                    </div>
                                    <h4>John Milton</h4>
                                    <h5>Head – Sales</h5>
                                </div>
                            </div>


                        </div>
                    </>
                </div>
            </section>

            <div className='inner_wrapper down-section'>
                <div className='content-box company_logo_box'>
                    <div className='container'>
                        <div className='row'>
                            <div className='col-lg-4'>
                                <div className='director-img'>
                                    <div class="card">
                                        <div class="background"></div>
                                        <img src={require('../../assets/images/blue-circle.avif')} alt="Profile Picture" />
                                        <div class="details">
                                            <h3 class="name">Dinesh Pratap Yadav</h3>
                                            <p className='wow fadeUp para_text2 text-dark'><strong>Chief Executive Officer</strong></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='col-lg-8'>
                                <div className='director-msg mt-4'>
                                    <p className='wow fadeUp para_text3'>In the current process of widespread globalization, we in CLOUD MIND understand that meeting our client's
                                        requirements is essential to the success of our organization. We can say that the months we experienced in the past are significant, and it is
                                        clearly seen that we have delivered our best performance, focusing on client satisfaction. On behalf of the Board of Directors, I would like to
                                        thank our valuable clients, reliable dealers, and world-class suppliers. Additionally, I would like to make a special mention of our staff’s enthusiastic contribution in establishing our organization.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <section class="empowering-global-wrp career_foster mt-5">
                <div class="container">
                    <div class="empowering-global-contant wow fadeInUp" data-wow-delay="0.1s">
                        <h2>Join the CLOUD MIND team!</h2>
                        <p class="career_foster_text"> Explore cutting-edge technologies and dive into some of the most exciting projects you can imagine.</p>
                        <p><Link to="/career" class="joinus-link">Apply Now</Link></p>
                    </div>
                </div>
            </section>

            <section className='security-program-section bottom top'>
                <div className='container'>
                    <div className='sub-heading-text'>
                        <h2 className='text-center text-white'>Boost Your Cyber Security Advancements</h2>
                        <div class="divider-wrapper small"></div>
                    </div>
                    <div className='row mt-4'>
                        <div className='col-lg-3 col-md-6 mt-3'>
                            <div className='advancements'>
                                <h3>Network and Infrastructure Security</h3>
                                <p className='wow fadeUp'>Technical Assurance Services for a Secure Cloud Computing Transition</p>
                                <Link to="/enterprise-network-ndr"><i class="fa fa-arrow-right" aria-hidden="true"></i></Link>
                            </div>
                        </div>
                        <div className='col-lg-3 col-md-6 mt-3'>
                            <div className='advancements'>
                                <h3>Cloud Security</h3>
                                <p className='wow fadeUp'>Industrial Control Systems Security to protect Critical Infrastructure</p><br />
                                <Link to="/cloud"><i class="fa fa-arrow-right" aria-hidden="true"></i></Link>
                            </div>
                        </div>
                        <div className='col-lg-3 col-md-6 mt-3'>
                            <div className='advancements'>
                                <h3>ICS/OT Security</h3>
                                <p className='wow fadeUp'>Hunting Cyber Adversaries with SOC as a Service by DTS</p><br />
                                <Link to="/ics-security"><i class="fa fa-arrow-right" aria-hidden="true"></i></Link>
                            </div>
                        </div>
                        <div className='col-lg-3 col-md-6 mt-3'>
                            <div className='advancements'>
                                <h3>24x7 Managed CSOC and MDR</h3>
                                <p className='wow fadeUp'>Advanced Next Generation Enterprise Network Security</p>
                                <Link to="/mdr"><i class="fa fa-arrow-right" aria-hidden="true"></i></Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <FooterContact />

        </>
    )
}
